var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "map-wrap" },
    [
      _c(
        "GmapMap",
        {
          ref: "map",
          attrs: {
            center: { lat: _vm.lat, lng: _vm.long },
            zoom: _vm.zoom,
            options: _vm.mapOptions
          },
          on: {
            center_changed: function($event) {
              return _vm.updateCenter($event)
            }
          }
        },
        [
          _c(
            "GmapCluster",
            {
              attrs: {
                position: { lat: _vm.lat, lng: _vm.long },
                clickable: true,
                animation: 2,
                styles: _vm.clusterStyles,
                zoomOnClick: true
              }
            },
            _vm._l(_vm.markers, function(marker, index) {
              return _c("GmapMarker", {
                key: index,
                attrs: {
                  position: marker.position,
                  clickable: true,
                  draggable: false,
                  label: marker.label,
                  icon: _vm.getMarkers(index)
                },
                on: {
                  click: function($event) {
                    return _vm.toggleInfoWindow(marker.position.id, index)
                  }
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("InfoWindow", { attrs: { infoWindow: _vm.infoWindow } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41afbb42", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41afbb42","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/locations/Map.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-41afbb42","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/locations/Map.vue
// module chunks = 0